import React from 'react';
import './BackgroundVerticalLines.scss';

const arr = new Array(6).fill( <div style ={{ borderBottom: '2px solid #3b3a3b'}}/>);
const BackgroundVerticalLines = ()=> {
  return (
    <div className='background-vertical-lines' style={{  width: '100%' ,height: '100%'  }}>
      {arr.map(item => item )}
    </div>
  );
};

export default BackgroundVerticalLines;
